import * as React from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { StyledTagSelect } from './TagSelect.styles';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

const StyledClearButton = createPrefixedPropsFilteredComponent<{ $visible: boolean }>(IconButton)(({ $visible }) => ({
  visibility: $visible ? 'visible' : 'hidden'
}));

interface TagSelectProps {
  options: string[];
  selectedOption: string;
  onChange: (value: string) => void;
  noOptionsText: string;
}

const TagSelect: React.FC<TagSelectProps> = ({ options, selectedOption, onChange, noOptionsText }) => {
  const [textFieldValue, setTextFieldValue] = React.useState<string>('');
  const [hover, setHover] = React.useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <StyledTagSelect
      options={options}
      noOptionsText={noOptionsText}
      getOptionLabel={(option: string) => option}
      onInputChange={(e, newValue) => {
        setTextFieldValue(newValue);
      }}
      value={selectedOption}
      onChange={(e, newValue) => { onChange(newValue || '') }}
      clearOnEscape={false}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('tagSelect.label')}
          variant="outlined"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Tab") {
              onChange(textFieldValue);
            }
          }}
          InputProps={{
            ...params.InputProps,
            sx: {
              height: '50px',
            },
            endAdornment: (
              <React.Fragment>
                <StyledClearButton
                  size="small"
                  edge="end"
                  $visible={!!(textFieldValue && hover)}
                  onClick={() => {
                    setTextFieldValue('');
                    onChange('');
                  }}
                >
                  <ClearIcon fontSize="small" />
                </StyledClearButton>
              </React.Fragment>
            ),
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        />
      )}
    />
  );
};

export default TagSelect;